import { useContext, useMemo } from 'react'
import { ContentContext } from '@/content/contentStore'
import { mapsUrl, telUrl, whatsappUrl } from '@/helpers/liens'

// Contenu modifiable du site (prédications, équipe, mot du pasteur, dons, contact).
export function useContent() {
  const ctx = useContext(ContentContext)
  if (!ctx) throw new Error('useContent doit être utilisé sous ContentProvider')
  return ctx
}

// Liens dérivés des coordonnées de contact (WhatsApp, itinéraire, appel).
export function useLiens() {
  const { contact } = useContent()
  return useMemo(
    () => ({
      whatsapp: whatsappUrl(contact.whatsapp),
      maps: mapsUrl(contact.lat, contact.lng),
      tel: telUrl(contact.telephone),
    }),
    [contact.whatsapp, contact.lat, contact.lng, contact.telephone],
  )
}
